import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import createDOMPurify from 'dompurify';

// Suppress Jodit AbortError spam - only for errors originating from Jodit text-editor
window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.message || '';
  const stack = event.reason?.stack || '';

  // Jodit creates AbortErrors with message "Abort async" during internal operations
  // These only occur on pages with text-editor component (TA, TC, TS, TSpec, etc.)
  const isJoditAbortError =
    event.reason?.name === 'AbortError' &&
    message.includes('Abort async');

  if (isJoditAbortError) {
    event.preventDefault();

    // Log in development mode for debugging visibility
    if (!environment.IsProduction) {
      console.debug('[Jodit AbortError suppressed]', { message, componentStack: stack.split('\n')[1]?.trim() });
    }
    return;
  }
});

if (environment.IsProduction) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));

const DOMPurify = createDOMPurify(window);
DOMPurify.addHook('uponSanitizeAttribute', function(node, data) {//for ensuring all event handler attributes are removed (description)
  if (data.attrName && data.attrName.startsWith('on')) {
    data.keepAttr = false;
  }
});